import { DuctType } from "@eisox/api/core-api";
import { cn } from "@eisox/design-system";
import { WindIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

import { Direction, Position, type Component } from "../types";
import { AirFlow } from "./air-flow";
import { Card } from "./card";
import { TemperatureSensor } from "./temperature-sensor";

interface InletProps extends Component {
  buildingId: string;
  airHandlerUnitId: string;
  type: DuctType.EXHAUST | DuctType.OUTSIDE;
  temperature?: number;
  temperatureDefect?: boolean;
  setpoint?: number;
}

const Inlet: React.FC<InletProps> = ({
  buildingId,
  airHandlerUnitId,
  type,
  temperature,
  temperatureDefect,
  setpoint,
  position = Position.TOP,
}) => (
  <div
    className={cn(
      "h-51.75 w-27.5 relative flex flex-col items-center",
      "after:h-23.5 after:absolute after:-z-2 after:w-full after:border-y after:border-primary-dark-gray after:bg-neutral-100 after:content-['']",
      position === Position.TOP ? "after:-bottom-px" : "after:-top-px",
    )}
  >
    <AirFlow
      className={cn("absolute", position === Position.TOP ? "bottom-2.5" : "top-2.5")}
      direction={type === DuctType.EXHAUST ? Direction.LEFT : Direction.RIGHT}
    />
    {temperature !== undefined && (
      <TemperatureSensor
        className={position === Position.TOP ? "bottom-0" : "top-0"}
        buildingId={buildingId}
        airHandlerUnitId={airHandlerUnitId}
        position={position}
        temperature={temperature}
        defect={temperatureDefect}
        setpoint={setpoint}
      />
    )}
    <Card className={cn("absolute cursor-default", position === Position.BOTTOM && "bottom-0")}>
      <WindIcon />
      {m[type]()}
    </Card>
  </div>
);

Inlet.displayName = "Inlet";

export { Inlet };
export type { InletProps };
